import _                                                                                                         from 'underscore';
import React, { FC, useLayoutEffect }                                                                            from 'react';
import { Icon, Label, SemanticICONS }                                                                            from 'semantic-ui-react';
import { StyledContainer }                                                                                       from '../../../containers';
import { SemanticUIColor, Size, SystemEvent }                                                                    from '../../../../types';
import { ENVIRONMENT_IS_DEVELOPMENT, ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_STAGING, ENVIRONMENT_IS_TESTING } from '../../../../constants/SystemEnums';

export interface ScriptLoaderWithVisualBugProps {
	label?: string,
	icon?: SemanticICONS,
	iconFlipped?: boolean,
	color?: SemanticUIColor,
	position?: string,
	positionOffset?: number | string | number[] | string[],
	inProduction?: boolean,
	inTesting?: boolean,
	inStaging?: boolean,
	inDevelopment?: boolean,
	useVisualBug?: boolean,
	
	onClick?( e: SystemEvent ): void,
	
	onLoad?(): void,
	
	[ additionalProps: string ]: any
}

export interface VendorLoaderProps extends ScriptLoaderWithVisualBugProps {
	id?: string,
}

const defaultProps: ScriptLoaderWithVisualBugProps = {
	label:          'Provide Feedback',
	icon:           'chat',
	iconFlipped:    false,
	color:          SemanticUIColor.TEAL,
	position:       'bottom right',
	positionOffset: [ 20, 20 ],
	onClick:        null,
	onLoad:         null,
	inProduction:   true,
	inTesting:      true,
	inStaging:      true,
	inDevelopment:  true,
	useVisualBug:   true,
}

const ScriptLoaderWithVisualBug: FC<ScriptLoaderWithVisualBugProps> = ( props ) => {
	
	const { inProduction, inTesting, inStaging, inDevelopment } = props;
	
	useLayoutEffect( () => {
		
		if( validEnvironment() && _.isFunction( props.onLoad ) ){
			props.onLoad();
		}
		
	}, [] )
	
	const handleOnClick = ( e: SystemEvent ) => {
		
		e.preventDefault()
		
		if( validEnvironment() && _.isFunction( props.onClick ) ){
			props.onClick( e );
		}
	}
	
	const validEnvironment = () => {
		
		if( ENVIRONMENT_IS_PRODUCTION ){
			return inProduction;
		}
		if( ENVIRONMENT_IS_STAGING ){
			return inStaging;
		}
		if( ENVIRONMENT_IS_TESTING ){
			return inTesting;
		}
		if( ENVIRONMENT_IS_DEVELOPMENT ){
			return inDevelopment;
		}
		return true
	}
	
	let style: React.CSSProperties   = {
		    position:  'fixed',
		    transform: 'all 200ms ease-in-out',
	    },
	    { positionOffset, position } = props;
	
	if( !_.isArray( positionOffset ) ){
		positionOffset = [
			parseInt( positionOffset as string ),
			parseInt( positionOffset as string )
		];
	}
	
	switch( position ){
		case 'top left' :
			style.top  = positionOffset[ 0 ];
			style.left = positionOffset[ 1 ];
			break
		case 'bottom left' :
			style.bottom = positionOffset[ 0 ];
			style.left   = positionOffset[ 1 ];
			break
		case 'top right' :
			style.top   = positionOffset[ 0 ];
			style.right = positionOffset[ 1 ];
			break
		case 'bottom right' :
			style.bottom = positionOffset[ 0 ];
			style.right  = positionOffset[ 1 ];
			break
		default:
			style = {}
			break;
	}
	
	if( !validEnvironment() || !props.useVisualBug ) return null;
	
	return (
		
		<StyledContainer onClick={ handleOnClick } style={ { ...style } } className={ 'cursor--pointer' }>
			<Label circular color={ props.color }>
				<StyledContainer padding={ [ Size.XS, Size.SM ] }>
					<Icon name={ props.icon } style={ props.iconFlipped ? { transform: 'scaleX(-1)' } : {} }/>
					<span className={ 'display--inline-block margin-sm-left' }>{ props.label }</span>
				</StyledContainer>
			</Label>
		
		</StyledContainer>
	);
};

ScriptLoaderWithVisualBug.defaultProps = defaultProps;

export { ScriptLoaderWithVisualBug }
